import _ from 'lodash';
import { useContext, useEffect } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { AppUserContext } from '../../../../global/cnr/contexts/AppUserContext';
import { createInitials } from '../../../../global/common/dataAdjust';
import { formatItem, formatTimeAmPm, formatTypes } from '../../../../global/common/dateFormatting';
import { uniqueKey } from '../../../../global/common/keys';
import { TimePickerDirect } from '../../../../global/components/forms/elements/TimePicker';
import { gEnums } from '../../../../global/enums/globalEnums';
import { SeasonMatchesContext } from '../../cnr/contexts/SeasonMatchesContext';
import { SportsMatchContext } from '../../cnr/contexts/SportsMatchContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { matchDisplayTypes } from '../../cnr/reducers/SportsMatchReducer';
import { tournamentTypes } from '../../cnr/reducers/SportsTournamentReducer';
import { CreatePlayoffContext } from '../../create/CreatePlayoff';
import { getSectionColor } from '../../create/sectionColors';
import TeamList from '../teams/TeamList';
import MatchResultsRt from './MatchResultsRt';
import MatchScores from './MatchScores';
import MatchDivs from './MatchDivs';
import { _matchDisplayTypes } from './MatchContent';
import MatchOptionsSquares from './MatchOptionsSquares';
import { useMatchDisplayType } from 'projectSpecific/sports/useHelpers/useMatchDisplayType';
import { useMatchVideos } from 'projectSpecific/sports/useHelpers/useMatchVideos';
import { useMatchResults } from 'projectSpecific/sports/useHelpers/useMatchResults';
// import { MatchDivs } from './MatchDivs';

const nameLimit = 18

const PoolMatch = (props) => {

  const { match_edit, match, forGrid } = props

  let cn_matchGrid = forGrid ? 'match-grid' : ''

  const { _results } = match

  const appUserContext = useContext(AppUserContext);
  const { appUser_fns } = appUserContext ?? {}
  const accessLevel = appUser_fns.get_accessLevel()

  const allowEdits = {
    match: accessLevel >= gEnums.accessLevels.superAdminDeveloper.value ? true : false,
    location: accessLevel >= gEnums.accessLevels.superAdminDeveloper.value ? true : false
  }

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { _sportData } = sportsSeason_state ?? {}
  const { useRtMatchData } = _sportData ?? {}
  const allowRealTime = useRtMatchData

  // createPlayoffContext
  const createPlayoffContext = useContext(CreatePlayoffContext);
  const { createPlayoff_state, createPlayoff_handlers } = createPlayoffContext ?? {}
  const { showPlayoffMatchLocation, showPlayoffMatchTime } = createPlayoff_state ?? {}

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state, seasonMatches_handlers } = seasonMatchesContext ?? {}
  const { matchDisplayType, tournamentType, rt_matchKey } = seasonMatches_state ?? {}

  switch (tournamentType) {
    case tournamentTypes.newPlayoff:
      allowEdits.match = false
      break;
    default:
  }

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state } = sportsMatchContext ?? {}
  const { match_true, matchData_rt, matchAllows } = sportsMatch_state ?? {}
  const { _itemKey, home, location } = match_true ?? {}
  const { match_rt } = matchData_rt ?? {}
  const { edit: _allowEdit_match, scores: _allowEdit_scores, matchAccessLevel } = matchAllows ?? {}

  const loc = location ? location.name : null
  const locIsHome = home && loc && (loc === home.name)

  if (match && match.sectionMeeting && createPlayoff_state) { cn_matchGrid += ' sm' }

  const _umr = useMatchResults({ match_true })
  const { results_match, result_source } = _umr
  const { matchUrl } = useMatchVideos(match_true)
  const { mpt, matchProps } = useMatchDisplayType({ match_true, matchUrl, matchDisplayType })

  let _showMatchOptions;

  if (_allowEdit_scores && (rt_matchKey === _itemKey)) {
    switch (matchDisplayType) {
      case matchDisplayTypes.matchOptions:
      case matchDisplayTypes.realtimeScoring:
        _showMatchOptions = true
        break;
      default:
      // nothing
    }
  }

  const handleShowEdit = (e) => {
    e.stopPropagation()
    if (allowEdits.match) {
      // sportsSeason_handlers.handleShow_sportsElem(opts)
      seasonMatches_handlers.handleSelect_currentMatch(match_true, matchDisplayTypes.matchOptions)
    }
  }

  const handleShowLocation = (m) => {
    if (allowEdits.location && createPlayoff_handlers) {
      createPlayoff_handlers.handleShow_playoffMatchLocation(m)
    }
  }

  const handleShowTime = (m) => allowEdits.match && createPlayoff_handlers && createPlayoff_handlers.handleShow_playoffMatchTime(m)
  const handleSetLocation = (team) => allowEdits.match && createPlayoff_handlers && createPlayoff_handlers.handleAmmend_matchLocation(team)
  const handleSetTime = (t) => allowEdits.match && createPlayoff_handlers && createPlayoff_handlers.handleAmmend_matchTime(t.formatted12)

  useEffect(() => {
    // const tm = match_edit && (match_edit.key === match.key) ? match_edit : match 
    // sportsMatch_handlers && sportsMatch_handlers.handleSet_trueMatch(match)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [match_edit, match]);

  const handle_matchClick = () => {
    switch (tournamentType) {
      case tournamentTypes.newPlayoff:
        break;
      default:
        return seasonMatches_handlers.handleMatch_editClick({ key: 'matches' }, _itemKey, null, match_true)
    }
  }

  // const handleMatchClick_edit = (e) => {
  //   e.stopPropagation(e)
  //   seasonMatches_handlers.handleSelect_currentMatch(match_true, matchDisplayTypes.matchOptions)
  // }

  const getPendingMatch = (pending) => {
    if (pending) {
      const { round, roundKey, pool, place, poolName, matchNumber } = pending ?? {}
      if (roundKey === 'playoffs') {
        return poolName + ' #' + matchNumber + '/' + place
      } else {
        return 'R' + round + '/' + (poolName ? poolName + '-' + matchNumber : 'P' + pool) + '/' + place
      }
    } else {
      return null
    }
  }

  const locationPlayoffIcon = (isBye, locationNotConfirmed) => isBye ? ' ' : <Icon color={locationNotConfirmed ? 'yellow' : 'blue'} name={'map marker alternate'} />

  const locationPlayoffText = (isBye, locationName, homeName) => {
    let locationText = ''
    let locationNotConfirmed = false
    if (isBye) {
      locationText = ' '
    } else {
      if (!locationName) {
        locationText = homeName ? homeName : 'TBD'
        locationNotConfirmed = true
      } else {
        locationText = locationName
      }
    }
    return { locationText, locationNotConfirmed }
  }

  const teamDivs = (teamDivProps) => {
    const { _winner, _awayName, _awaySeed, away_cn, awayResult, _homeName, _homeSeed, home_cn, homeResult, seedLabel, seedColors, resultLabel } = teamDivProps
    const divs = []
    divs.push(<div key={uniqueKey('pm', 'ht')} className={away_cn}>{seedLabel(_awaySeed, seedColors.result.away)}<span>{_awayName}</span></div>)
    divs.push(<div key={uniqueKey('pm', 'at')} className={home_cn}>{seedLabel(_homeSeed, seedColors.result.home)}<span>{_homeName}</span></div>)
    divs.push(resultLabel('away', awayResult, seedColors.result.away, _winner === 'away' ? 'w' : null))
    divs.push(resultLabel('home', homeResult, seedColors.result.home, _winner === 'home' ? 'w' : null))
    return divs
  }

  const scoreElements = () => <MatchScores results={_results} />

  const trophyIcon = () => match.isPlayoff && <Icon color={'blue'} name={'trophy'} />

  const dateDivs = (match, locationText, locationNotConfirmed, extra, isBye, showResults, cn_matchDates) => {

    const { startDate, startTime } = match ?? {}

    const _startTime = formatTimeAmPm(startTime)

    const divs = []
    if (isBye) {
      divs.push(<div className={'match-date'}>{'---'}</div>)
      divs.push(<div className={'match-time'}>{'---'}</div>)
      divs.push(<div className={'match-location'}>{'---'}</div>)
    } else {
      if (startDate) {
        divs.push(<div key={uniqueKey('pm', 'md')} className={'match-date'}>{isBye ? ' ' : formatItem(formatTypes.dateDayMonth, startDate)}</div>)
      }
      if (_startTime) {
        divs.push(<div key={uniqueKey('pm', 'mt')} className={'match-time'} onClick={() => { handleShowTime(match) }}>{isBye ? '' : _startTime}</div>)
      }
      if (extra) {
        divs.push(<div key={uniqueKey('pm', 'mte')} className={'match-extra'}  >{extra}</div>)
      }
      if (locationText) {
        divs.push(<div key={uniqueKey('pm', 'mw')} className={'match-location plo'} onClick={() => { handleShowLocation(match) }}>{locationPlayoffIcon(isBye, locationNotConfirmed)}{locationText ? locationText : ''}</div>)
      }
      if (showResults) {
        divs.push(<div key={uniqueKey('pm', 'mr')} className={'match-results-se'}>{scoreElements()}</div>)
      }
    }

    return <div key={uniqueKey('pm', 'mdt')} className={cn_matchDates} onClick={(e) => { handleShowEdit(e, match) }}>
      {divs}
    </div>
  }

  const poolMatch = () => {

    console.log('poolMatch')

    // let _matchPropType = _matchDisplayTypes.playoff_noScore
    // const mdps = _matchDisplayProps[_matchPropType]

    const xxx = <MatchDivs
      // mdps={mdps}
      match={match_true}
      matchDisplayType={matchDisplayType}
      // _matchDisplayTypes={_matchDisplayTypes} 
      matchProps={matchProps}
      matchUrl={matchUrl}
    // matchScheduleDisplayType={matchScheduleDisplayType}
    // _teamKey={_teamKey}
    />

    const { home, away, work, matchNumber, seeds, courtNumber, pending, location, name: matchName, isPlayoff, isConsolation, ls, poolKey } = match_true ?? {}

    let _ls = ls

    if (isPlayoff) {
      _ls = _.startCase(poolKey)
      if (isConsolation) {
        _ls = _ls.replace('Finals', 'Consolation')
      } else if (isPlayoff) {
        if (poolKey !== 'finals') {
          _ls += ' - #' + matchNumber
        }
      }
    }

    const results_true = match_true ? match_true._results : undefined;
    const matchHasResults = !_.isEmpty(results_true)

    const _rstz = allowRealTime && match_rt ? match_rt : results_true


    const { home: home_pending, away: away_pending, work: work_pending } = pending ?? {}
    const { name: locationName } = location ?? {}
    const { score, scores, winner, setNumber, scoreDisplays, complete, extra } = _rstz ?? {}
    const { scores: scoreDisplay_scores, _scoreElements } = scoreDisplays ?? {}
    const { id: winnerId } = winner ?? {}

    const _currentSetScore = scores && setNumber && scores[setNumber] ? scores[setNumber] : score

    const _isPending = (home_pending || away_pending) && !home && !away

    const homeName = home ? home.name : getPendingMatch(home_pending)
    const awayName = away ? away.name : getPendingMatch(away_pending)
    const workName = work ? work.name : getPendingMatch(work_pending)

    console.log('homeName', homeName)

    const _homeName = homeName.length > nameLimit ? createInitials(homeName, 3) : homeName
    const _awayName = awayName.length > nameLimit ? createInitials(awayName, 3) : awayName

    const homeSeed = seeds ? seeds['home'] : null
    const awaySeed = seeds ? seeds['away'] : null

    let awayResult = score ? score.away : '-'
    let homeResult = score ? score.home : '-'

    const seedLabel = (seed, color) => <Label key={uniqueKey('pm', 'sl', seed)} color={color} circular size={'mini'}>{seed}</Label>
    const resultLabel = (team, teamScore, color, cn) => <div key={uniqueKey('pm', 'sl', team, teamScore)} className={'result-' + team + ' ' + cn} >{teamScore}</div>

    // const scoreLabel = (team, score, cn) => <div key={uniqueKey('pm', 'rl', team, score)} className={'score-' + team + ' ' + cn} >{score}</div>

    if (_homeName && _awayName) {

      const _awaySeed = away && away.seed && away.seed !== awaySeed ? away.seed : awaySeed
      const _homeSeed = home && home.seed && home.seed !== homeSeed ? home.seed : homeSeed

      let away_upset = false;
      let home_upset = false;

      away_upset = matchHasResults && away && away.id === winnerId ? true : false
      home_upset = matchHasResults && home && home.seed > homeSeed ? true : false

      const _winner = home && away
        ? (away.id === winnerId ? 'away' : home.id === winnerId ? 'home' : null)
        : null;

      const isBye = _awayName === 'BYE'

      const { locationText, locationNotConfirmed } = locationPlayoffText(isBye, locationName, _homeName)

      if (isBye) {
        cn_matchGrid += ' bye'
        awayResult = ''
        homeResult = <Icon color='green' name='check circle outline' />
      }
      if (isConsolation) { cn_matchGrid += ' consolation' }

      const matchDivs = []

      let match_cn = 'pool-match'
      let away_cn = 'match-away'
      let home_cn = 'match-home'
      let pool_cn = 'pool-match ppp'

      if (complete || isBye) { cn_matchGrid += ' complete' }
      if (_isPending) { cn_matchGrid += ' pending' }

      if (forGrid) {

        let cn_matchDates = 'match-dates'
        if (matchAccessLevel) { match_cn += ' mal-' + matchAccessLevel }
        if (1 === 1 || !locIsHome) {
          cn_matchDates += ' loc'
        }

        const showResults = !_.isEmpty(scores) ? true : false

        if (showResults) { cn_matchDates += ' results' }
        if (extra) { cn_matchDates += ' ext' }

        const seedColors = {
          result: {
            away: 'grey',
            home: 'grey',
          },
          score: {
            away: 'grey',
            home: 'grey',
          }
        }

        const { sections: section_away } = away ?? {}
        const { sections: section_home } = home ?? {}

        if (section_away) { seedColors.result.away = getSectionColor(section_away) }
        if (section_home) { seedColors.result.home = getSectionColor(section_home) }

        if (away_upset) (away_cn += ' upset')
        if (home_upset) (home_cn += ' upset')

        if (winnerId && _winner === 'away') { away_cn += ' w' }
        if (winnerId && _winner === 'home') { home_cn += ' w' }

        if (winnerId && _winner === 'away') { match_cn += ' wa' }
        if (winnerId && _winner === 'home') { match_cn += ' wh' }

        if (allowRealTime && match_rt && _currentSetScore) {
          match_cn += ' rt'
          seedColors.score.away = _currentSetScore.home > _currentSetScore.away ? 'up' : _currentSetScore.home < _currentSetScore.away ? 'down' : 'tie'
          seedColors.score.home = _currentSetScore.away > _currentSetScore.home ? 'up' : _currentSetScore.away < _currentSetScore.home ? 'down' : 'tie'
        }

        const teamDivProps = {
          _awayName,
          _awaySeed,
          _homeName,
          _homeSeed,
          _winner,
          away_cn,
          awayResult,
          home_cn,
          homeResult,
          resultLabel,
          seedColors,
          seedLabel,
        }

        let cn_teams = 'teams'

        matchDivs.push(<div className={match_cn} key={uniqueKey(pool_cn)} onClick={() => { !isBye && handle_matchClick() }}>
          <div className={'match-ls'}><Label color='black' size='tiny'>{trophyIcon()}{_ls}</Label></div>
          <div className={cn_teams}>
            {teamDivs(teamDivProps)}
          </div>
          {match_rt && <MatchResultsRt match={match} />}
          {dateDivs(match_true, locationText, locationNotConfirmed, extra, isBye, showResults, cn_matchDates)}
        </div>)

        if (_showMatchOptions) {
          matchDivs.push(< MatchOptionsSquares match_true={match_true} />)
        }
      } else {
        if (courtNumber) {
          matchDivs.push(<div className={'pool-header'}>
            {!location && <div key={uniqueKey('pm', 'mc')} className={'match-court'}>{'Match #'}{matchNumber}{' - '}{'court '}{courtNumber}</div>}
            {!location && <div key={uniqueKey('pm', 'mw')} className={'match-work'}>{'Work: '}{workName}</div>}
          </div>)
        } else {
          matchDivs.push(<div className={'pool-header'}>
            {<div key={uniqueKey('pm', 'mc')} className={'match-court'}>{matchName}{' #'}{matchNumber}</div>}
            {locationName && <div key={uniqueKey('pm', 'mw')} className={'match-work'}>{'Location: '}{locationName}</div>}
          </div>)
        }
        matchDivs.push(<div className={pool_cn}>
          <div key={uniqueKey('pm', 'pm', 'at')} className={away_cn}>{<Label color={'green'} size={'mini'}>{awaySeed}</Label>}{_awayName}</div>
          <div key={uniqueKey('pm', 'pm', 'ht')} className={home_cn}>{_homeName}<Label color={'green'} size={'mini'}>{homeSeed}</Label></div>
        </div>)
      }


      return <div
        key={uniqueKey('pm', 'pm')}
        className={cn_matchGrid}
      >
        {xxx}
      </div>
    }
  }

  // const getMatchDivs = () => {
  //   const _matchPropType = _matchDisplayProps.playoff
  // }

  if (showPlayoffMatchLocation && 1 === 3) {
    return <TeamList handleCancel={handleShowLocation} handleSelect={handleSetLocation} contentOnly={true} />
  } else if (showPlayoffMatchTime) {
    return <TimePickerDirect handleCancel={handleShowTime} initialValue={match.startTime} handleDone={handleSetTime} />
  } else {
    return match_true ? poolMatch() : <div></div>
  }

}

export default PoolMatch